import React from 'react';
import {
  Box,
  Typography,
  Grid,
  Paper,
  Button,
  Stack,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import {
  PersonAdd,
  Person,
  Edit,
  Lock,
  Search,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const AdminManagementPage: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const navigate = useNavigate();

  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <Box 
        sx={{ 
          padding: { xs: "16px", md: "24px" }, 
          backgroundColor: theme.palette.grey[50], 
          borderBottom: `1px solid ${theme.palette.divider}`,
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
        }}
      >
        <Typography variant={isMobile ? "h6" : "h5"} sx={{ fontWeight: 600, mb: 3 }}>
          Admin Management
        </Typography>

        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Paper elevation={2} sx={{ borderRadius: 2, overflow: 'hidden' }}>
              <Box sx={{ p: 2 }}>
                <Typography variant="h6" sx={{ fontWeight: 600, color: theme.palette.primary.main }}>
                  Agent Management
                </Typography>
              </Box>
              <Box sx={{ p: 3 }}>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                  Create and manage agent users in the system
                </Typography>
                <Stack spacing={2}>
                  <Button
                    variant="contained"
                    startIcon={<PersonAdd />}
                    onClick={() => navigate('/admin/create-agent')}
                    fullWidth
                    sx={{ textTransform: 'none' }}
                  >
                    Create New Agent
                  </Button>
                  <Button
                    variant="outlined"
                    startIcon={<Lock />}
                    onClick={() => navigate('/admin/set-agent-password')}
                    fullWidth
                    sx={{ textTransform: 'none' }}
                  >
                    Set Agent Password
                  </Button>
                </Stack>
              </Box>
            </Paper>
          </Grid>

          <Grid item xs={12} md={6}>
            <Paper elevation={2} sx={{ borderRadius: 2, overflow: 'hidden' }}>
              <Box sx={{ p: 2 }}>
                <Typography variant="h6" sx={{ fontWeight: 600, color: theme.palette.secondary.main }}>
                  System User Management
                </Typography>
              </Box>
              <Box sx={{ p: 3 }}>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                  Create and manage system users with client/non-client access
                </Typography>
                <Stack spacing={2}>
                  <Button
                    variant="contained"
                    color="secondary"
                    startIcon={<Person />}
                    onClick={() => navigate('/admin/create-system-user')}
                    fullWidth
                    sx={{ textTransform: 'none' }}
                  >
                    Create System User
                  </Button>
                  <Button
                    variant="outlined"
                    color="secondary"
                    startIcon={<Edit />}
                    onClick={() => navigate('/admin/edit-system-user')}
                    fullWidth
                    sx={{ textTransform: 'none' }}
                  >
                    Edit System User
                  </Button>
                  <Button
                    variant="outlined"
                    color="secondary"
                    startIcon={<Search />}
                    onClick={() => navigate('/admin/user-status-check')}
                    fullWidth
                    sx={{ textTransform: 'none' }}
                  >
                    User Status Check
                  </Button>
                </Stack>
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default AdminManagementPage;